declare global {
  interface Window {
    umami?: {
      track: (eventName: string, eventData?: Record<string, string | number>) => void;
    };
  }
}

export function trackEvent(name: string, data?: Record<string, string | number>) {
  try {
    window.umami?.track(name, data);
  } catch {
    // Silently fail if Umami is not loaded
  }
}

export const analytics = {
  addToCart: (productName: string, price: number) =>
    trackEvent('add-to-cart', { product: productName, price }),

  checkoutStart: (total: number, itemCount: number) =>
    trackEvent('checkout-start', { total, items: itemCount }),

  purchase: (orderId: string, total: number) =>
    trackEvent('purchase', { order_id: orderId, total }),

  search: (query: string, resultCount: number) =>
    trackEvent('search', { query, results: resultCount }),

  newsletterSignup: (source: string) =>
    trackEvent('newsletter-signup', { source }),

  productView: (productName: string, slug: string) =>
    trackEvent('product-view', { product: productName, slug }),

  /**
   * Social-casino acquisition funnel: land → play → first spin → day-1 return
   * → first purchase. Only the first hop happens on the marketing site — every
   * later step is inside the embedded game app, which reports its own — so
   * these events answer one question: which homepage surface sends people into
   * the game, and how many of them get there at all.
   *
   * `surface` is the section that owned the click (hero, games-grid,
   * embed-teaser), so the sections can be ranked against each other rather
   * than collapsing into one undifferentiated /play pageview.
   */
  playClick: (surface: string, game?: string) =>
    trackEvent('play-click', game ? { surface, game } : { surface }),
};
